import React from 'react';
import { connect } from 'react-redux';

import * as actions from './documentDucks';
import DocumentHeader from './DocumentHeader.jsx';
import DocumentContent from './DocumentContent.jsx';

class DocumentPage extends React.Component {

  componentDidMount() {
    const {
      loadDocument,
      params: {
        documentId,
        attachmentId,
      },
    } = this.props;
    loadDocument(documentId, attachmentId);
  }

  componentWillUnmount() {
    const { resetDocument } = this.props;
    resetDocument();
  }

  // eslint-disable-next-line class-methods-use-this
  render() {
    return (
      <div className="page page-doc">
        <DocumentHeader/>
        <DocumentContent/>
      </div>
    );
  }
}

export default connect(null, actions)(DocumentPage);



// WEBPACK FOOTER //
// ./book/src/document/DocumentPage.jsx